import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import * as a11y from '@shopify/theme-a11y';
import Swiper, { Navigation, Pagination, Thumbs, EffectFade } from 'swiper';
import * as ProductUtil from '../utilities/product-utils';
import * as Helpers from '../utilities/helpers';
import * as DesignModeUtil from '../utilities/design-mode-util';
Swiper.use([Navigation, Pagination, Thumbs, EffectFade]);
Avatar.theme = Avatar.theme || {};

function Product() {
  var _this = this;

  var sectionName = 'main-product';
  var sectionId = Helpers.getSectionIdByName(sectionName);
  var selectors = {
    productContainer: '[data-product-container]',
    productMedia: '.product-media',
    productMediaItem: '[data-media-id]',
    productImageZoomWrapper: '[data-image-zoom-wrapper]',
    productMediaNav: '.product-media-nav',
    productMediaNavItem: '.product-media-nav-item',
    productForm: '.product-form',
    storeAvailabilityContainer: '[data-store-availability-container]',
    productTabs: '[data-tabs]',
    productVariant: '.product-variant',
    productSku: '[data-sku]',
    productQuantityStep: '.product-quantity-step',
    productQuantityInput: '.product-quantity-input',
    productPrices: '.product-prices',
    productPrice: '.product-price',
    productComparePrice: '.product-compare-price',
    productUnitPrice: '[data-unit-price]',
    productUnitPriceBase: '[data-unit-price-base-unit]',
    productButton: '.product-button',
    productButtonText: '.product-button__text',
    productOption: '.product-option',
    productOptionByIdex: function productOptionByIdex(index) {
      return "[data-product-option-".concat(index, "]");
    },
    productOptionLabel: '.form-check-label',
    productOptions: '[data-product-options]',
    checkedInput: 'input:checked',
    productHandle: '[data-product-handle]',
    jsPlayer: '.js-player',
    ytPlayer: '.yt-player',
    vmPlayer: '.vm-player',
    modelViewer: '.model-viewer',
    swatchInputById: function swatchInputById(id) {
      return "[id='".concat(id, "']");
    },
    swatchByOptionIndex: function swatchByOptionIndex(index) {
      return ".form-check-swatch[data-option-index=\"".concat(index, "\"]");
    },
    swatchInputByOptionIndex: function swatchInputByOptionIndex(index) {
      return "\n      .form-check-swatch[data-option-index=\"".concat(index, "\"]\n      .form-check-input\n    ");
    },
    stickyCart: '.sticky-cart',
    stickyAddCart: '[data-sticky-add-to-cart]',
    stickySelectOptions: '[data-select-options]',
    intersect: '[data-intersect]',
    sliderNext: '.swiper-button-next',
    sliderPrev: '.swiper-button-prev',
    sliderNavThumbActive: function sliderNavThumbActive(name) {
      return ".".concat(name);
    },
    sectionById: function sectionById(id) {
      return "#shopify-section-".concat(id);
    },
    productJsonById: function productJsonById(id) {
      return "#ProductJson-".concat(id);
    }
  };
  var classes = {
    soldout: 'soldout',
    hideOption: 'hide-option',
    showOption: 'show-option',
    active: 'active',
    hidden: 'tw-hidden',
    invisible: 'tw-invisible',
    defaultCursor: 'tw-cursor-default',
    sliderDisabledClass: 'swiper-button-disabled invisible',
    sliderNavThumbActive: 'swiper-slide-thumb-active',
    opacityNone: 'tw-opacity-0',
    heightNone: 'tw-h-0',
    iframeWrapper: 'tw-video-wrapper'
  };
  var ENTER_KEY_CODE = 13;
  var SPACE_KEY_CODE = 32;
  var productMedia;
  var zoomPictures = [];
  var productMediaNav;
  var jsPlayers;
  var ytPlayers = [];
  var modelViewers;
  var productContainer;
  var settings = {};

  function cacheSelectors() {
    var container = document.querySelector(selectors.sectionById(sectionId));
    this.productMedia = container.querySelector(selectors.productMedia);
    this.productMediaItems = container.querySelectorAll(selectors.productMediaItem);
    this.productImageZoomWrapper = container.querySelectorAll(selectors.productImageZoomWrapper);
    this.productMediaNav = container.querySelector(selectors.productMediaNav);
    this.productMediaNavButtons = container.querySelectorAll(selectors.productMediaNavItem);
    this.productForm = container.querySelector(selectors.productForm);
    this.storeAvailabilityContainer = container.querySelector(selectors.storeAvailabilityContainer);
    this.productTabs = container.querySelector(selectors.productTabs);
    this.productVariant = container.querySelector(selectors.productVariant);
    this.productSku = container.querySelector(selectors.productSku);
    this.productQuantityStep = container.querySelectorAll(selectors.productQuantityStep);
    this.productQuantityInput = container.querySelector(selectors.productQuantityInput);
    this.productPrices = container.querySelector(selectors.productPrices);
    this.productPrice = container.querySelector(selectors.productPrice);
    this.productComparePrice = container.querySelector(selectors.productComparePrice);
    this.productUnitPrice = container.querySelector(selectors.productUnitPrice);
    this.productUnitPriceBase = container.querySelector(selectors.productUnitPriceBase);
    this.productButton = container.querySelector(selectors.productButton);
    this.productButtonText = container.querySelector(selectors.productButtonText);
    this.productOption = container.querySelectorAll(selectors.productOption);
    this.productOptions = container.querySelector(selectors.productOptions);
    this.productHandle = container.querySelector(selectors.productHandle);
    this.intersect = document.querySelector(selectors.intersect);
    this.ytPlayers = container.querySelectorAll(selectors.ytPlayer);
    this.vmPlayers = container.querySelectorAll(selectors.vmPlayer);
    this.jsPlayers = container.querySelectorAll(selectors.jsPlayer);
    this.ytAPI = [];
    this.vmAPI = [];
    this.modelViewers = container.querySelectorAll(selectors.modelViewer);
    this.mqSmall = window.matchMedia(Avatar.theme.settings.mediaQuery.small);
    this.mqSmall.onchange = initImageZoom.bind(this);
  }

  var init = function init() {
    cacheSelectors.bind(_this)();
    initProductMedia.bind(_this)();
    initImageZoom.bind(_this)();
    initStoreAvailability.bind(_this)();
    initProductForm.bind(_this)();
    initProductTabs.bind(_this)();
    initRteIframes.bind(_this)();
    initProductQuantity.bind(_this)();
    initStickyCart.bind(_this)();
    initEventHandlers.bind(_this)();
    settings = getSettings();
  };

  function getSettings() {
    productContainer = document.querySelector(selectors.productContainer);

    if (!productContainer) {
      return false;
    }

    settings = JSON.parse(productContainer.getAttribute('data-product-settings'));
    return settings;
  }

  function initProductMedia() {
    var _this2 = this;

    if (!this.productMedia) {
      return;
    }

    if (this.productMediaItems.length <= 1) {
      this.productMediaItems[0].classList.remove(classes.invisible);
    }

    if (this.jsPlayers.length > 0) {
      Shopify.loadFeatures([{
        name: 'video-ui',
        version: '1.0',
        onLoad: setupPlyrVideos.bind(this)
      }]);
      Avatar.theme.LibraryLoader.load('plyrShopifyStyles');
    }

    if (this.ytPlayers.length > 0) {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = function () {
        _this2.ytPlayers.forEach(function (player) {
          _this2.ytAPI.push(new YT.Player(player));
        });
      };
    }

    if (this.vmPlayers.length > 0) {
      var _tag = document.createElement('script');

      _tag.src = 'https://player.vimeo.com/api/player.js';
      var _firstScriptTag = document.getElementsByTagName('script')[0];

      _firstScriptTag.parentNode.insertBefore(_tag, _firstScriptTag);

      Helpers.checkVimeoReady().then(function () {
        _this2.vmPlayers.forEach(function (player) {
          _this2.vmAPI.push(new Vimeo.Player(player));
        });
      }).catch(function (err) {
        return console.log(err);
      });
    }

    if (this.modelViewers.length > 0) {
      Avatar.theme.ProductModel.init(sectionId);
    }

    if (this.productMediaNav) {
      var self = this;
      this.productMediaNavSwiper = new Swiper(this.productMediaNav, {
        observer: true,
        observeParents: true,
        slidesPerView: 6,
        spaceBetween: 1,
        watchOverflow: true,
        touchRatio: 1,
        breakpoints: {
          768: {
            slidesPerGroup: 2,
            touchRatio: 0,
            navigation: {
              nextEl: selectors.sliderNext,
              prevEl: selectors.sliderPrev,
              disabledClass: classes.sliderDisabledClass
            }
          }
        },
        on: {
          afterInit: function afterInit() {
            window.onload = function () {
              self.productMediaNav.classList.add('loaded');
              self.productMedia.classList.add('loaded');
            };
          }
        }
      });
      this.productMediaSwiper = new Swiper(this.productMedia, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: selectors.sliderNext,
          prevEl: selectors.sliderPrev,
          disabledClass: classes.sliderDisabledClass
        },
        preloadImages: false,
        autoHeight: true,
        simulateTouch: false,
        preventClicks: false,
        preventClicksPropagation: false,
        followFinger: false,
        thumbs: {
          swiper: self.productMediaNavSwiper,
          autoScrollOffset: 2,
          slideThumbActiveClass: classes.sliderNavThumbActive
        },
        on: {
          afterInit: function afterInit() {
            self.productMediaNav.classList.remove(classes.heightNone);
            setTimeout(function () {
              if (self.productMediaItems[0].hasAttribute('data-product-media-type-model')) {
                self.productMediaSwiper.allowTouchMove = false;
              }
            }, 0);
          },
          slideChange: function slideChange() {
            if (self.productMediaSwiper.slides.length > 0) {
              var eventOptions = {
                bubbles: true,
                cancelable: true,
                detail: {
                  swiper: self.productMediaSwiper
                }
              };
              var _self$productMediaSwi = self.productMediaSwiper,
                  _slides = _self$productMediaSwi.slides,
                  previousIndex = _self$productMediaSwi.previousIndex,
                  _realIndex = _self$productMediaSwi.realIndex;
              var previousSlide = _slides[previousIndex];
              var currentSlide = _slides[_realIndex];
              previousSlide.dispatchEvent(new CustomEvent('mediaHidden', eventOptions));
              currentSlide.dispatchEvent(new CustomEvent('mediaVisible', eventOptions));
              currentSlide.classList.remove(classes.invisible);
            }

            var _self$productMediaSwi2 = self.productMediaSwiper,
                slides = _self$productMediaSwi2.slides,
                realIndex = _self$productMediaSwi2.realIndex;

            if (self.ytAPI.length > 0) {
              self.ytAPI.forEach(function (player) {
                return player.pauseVideo();
              });
              self.ytAPI.forEach(function (player) {
                if (player.h === slides[realIndex].firstElementChild) {
                  player.playVideo();
                }
              });
            }

            if (self.vmAPI.length > 0) {
              self.vmAPI.forEach(function (player) {
                return player.pause();
              });
              self.vmAPI.forEach(function (player) {
                if (player.element === slides[realIndex].firstElementChild) {
                  player.play();
                }
              });
            }

            if (self.jsPlayers) {
              self.jsPlayers.forEach(function (player) {
                return player.pause();
              });
              self.jsPlayers.forEach(function (player) {
                if (player.elements.container === slides[realIndex].firstElementChild) {
                  player.play();
                }
              });
            }

            setCurrentSlideAttributes.bind(self)();
          }
        }
      });
      this.productMediaNav.addEventListener('keydown', handleThumbnailKeyDown.bind(this));
      this.productMediaNavButtons.forEach(function (button) {
        button.addEventListener('click', handleThumbnailClick.bind(_this2));
      });
    }
  }

  function handleThumbnailKeyDown(evt) {
    if (![SPACE_KEY_CODE, ENTER_KEY_CODE].includes(evt.keyCode)) {
      return;
    }

    var index = Array.from(this.productMediaNav.querySelectorAll(selectors.productMediaNavItem)).indexOf(evt.target);
    this.productMedia.swiper.slideTo(index);
  }

  function setCurrentSlideAttributes() {
    var _this3 = this;

    var thumbs = this.productMediaNav.querySelectorAll(selectors.productMediaNavItem);
    thumbs.forEach(function (thumb) {
      return thumb.removeAttribute('aria-current');
    });
    setTimeout(function () {
      var activeThumb = _this3.productMediaNav.querySelector(selectors.sliderNavThumbActive(classes.sliderNavThumbActive));

      if (activeThumb) {
        activeThumb.setAttribute('aria-current', true);
      }
    }, 300);
  }

  function handleThumbnailClick(evt) {
    var currentTarget = evt.currentTarget;
    var slideIndex = currentTarget.dataset.slideIndex;
    var targetSlide = this.productMediaSwiper.slides[slideIndex];
    this.productMediaSwiper.slideTo(slideIndex);
    targetSlide.classList.remove(classes.invisible);
    Helpers.forceFocus(targetSlide, {
      preventScroll: true
    });
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      return;
    }

    this.jsPlayers = Shopify.Plyr.setup(selectors.jsPlayer);
  }

  function initImageZoom() {
    var _getSettings = getSettings(),
        enableImageZoom = _getSettings.enableImageZoom;

    if (!enableImageZoom) return;

    if (this.mqSmall.matches) {
      this.productImageZoomWrapper.forEach(function (element, index) {
        return destroyZoom(index);
      });
      return;
    }

    this.productImageZoomWrapper.forEach(function (element, index) {
      return enableZoom(element, index);
    });
  }

  function enableZoom(el, idx) {
    zoomPictures[idx] = new Avatar.theme.Zoom(el);
  }

  function destroyZoom(idx) {
    if (zoomPictures.length === 0) return;
    zoomPictures[idx].unload();
  }

  function initProductForm() {
    var jsonTag = document.querySelector(selectors.productJsonById(sectionId));

    if (!jsonTag || !jsonTag.innerHTML.length) {
      return;
    }

    var productJson = JSON.parse(jsonTag.innerHTML);

    if (!productJson.available && !settings.showUnavailable) {
      this.productOption.forEach(function (options) {
        return options.classList.add(classes.hidden);
      });
    }

    var self = this;

    if (productJson && productJson.options.length >= 1) {
      if (settings.variantSelectors === 'swatches') {
        initLinkedOptions(productJson);
      }

      if (settings.fadeInSelectors) {
        this.productOptions.classList.remove(classes.opacityNone);
      }
    }

    productJson.options = productJson.options.map(function (option) {
      return {
        name: option
      };
    });
    var productForm = new Avatar.theme.ProductForm(this.productForm, productJson, {
      onOptionChange: function onOptionChange(e) {
        var _e$dataset = e.dataset,
            variant = _e$dataset.variant,
            options = _e$dataset.options;
        ProductUtil.renderMedia(self.productMediaSwiper, variant, self.productMediaItems);
        ProductUtil.renderPrice(self.productPrices, self.productPrice, variant);
        ProductUtil.renderComparePrice(self.productComparePrice, variant);
        ProductUtil.renderUnitPrice(self.productUnitPrice, self.productUnitPriceBase, variant);
        ProductUtil.renderSku(self.productSku, variant);
        ProductUtil.renderButton(self.productButtonText, variant);
        ProductUtil.updateVariant(self.productVariant, variant);
        ProductUtil.updateBrowserHistory(variant);
        ProductUtil.updateStoreAvailabilityContent(self.storeAvailability, variant);

        if (settings.variantSelectors === 'swatches') {
          updateSwatches(productJson);
        }
      }
    });
    this.productForm.dispatchEvent(new CustomEvent('product:form:loaded', {
      detail: {
        variant: productForm.variant(),
        target: productForm
      },
      bubbles: true
    }));
    var currentVariant = productForm.variant();
    var currentOptions = productForm.options();
    ProductUtil.renderMedia(this.productMediaSwiper, currentVariant, this.productMediaItems);
    ProductUtil.renderButton(self.productButtonText, currentVariant);

    if (this.storeAvailability && currentVariant.available) {
      this.storeAvailability.updateContent(currentVariant.id);
    }

    if (settings.ajaxSubmit) {
      DesignModeUtil.initAjaxAddToCart();
    }
  }

  function initStoreAvailability() {
    if (!this.storeAvailabilityContainer) return;
    this.storeAvailability = new Avatar.theme.StoreAvailability(this.storeAvailabilityContainer);
  }

  function initProductTabs() {
    if (!this.productTabs) return;
    this.productTabs = new Avatar.theme.Tabs(this.productTabs);
  }

  function initRteIframes() {
    var iframes = Avatar.theme.rte.iframeSelectors;
    Avatar.theme.rte.wrapIframe({
      iframes: document.querySelectorAll(iframes),
      iframeWrapperClass: classes.iframeWrapper
    });
  }

  function initProductQuantity() {
    var _this4 = this;

    if (this.productQuantityStep.length === 0) return;
    this.productQuantityStep.forEach(function (step) {
      return step.addEventListener('click', handleQuantityClick.bind(_this4));
    });
    this.productQuantityInput.addEventListener('change', handleQuantityChange.bind(this));
  }

  function handleQuantityClick(evt) {
    var currentTarget = evt.currentTarget;

    if (currentTarget.hasAttribute('data-step-up')) {
      this.productQuantityInput.stepUp();
    } else if (currentTarget.hasAttribute('data-step-down')) {
      this.productQuantityInput.stepDown();
    }

    if (parseInt(this.productQuantityInput.value, 10) <= 1) {
      this.productQuantityInput.previousElementSibling.setAttribute('disabled', true);
    } else {
      this.productQuantityInput.previousElementSibling.removeAttribute('disabled');
    }
  }

  function handleQuantityChange(evt) {
    var currentTarget = evt.currentTarget;

    if (currentTarget.value === '1') {
      currentTarget.previousElementSibling.setAttribute('disabled', true);
    } else {
      currentTarget.previousElementSibling.removeAttribute('disabled');
    }
  }

  var getProductJson = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var handle, product;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handle = _this.productHandle.getAttribute('data-product-handle');
              _context.next = 3;
              return fetch("/products/".concat(handle, ".js")).then(function (response) {
                return response.json();
              });

            case 3:
              product = _context.sent;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getProductJson() {
      return _ref.apply(this, arguments);
    };
  }();
  /* Sticky Cart */


  function initStickyCart() {
    var stickyCart = document.querySelector(selectors.stickyCart);
    var stickyAddCart = document.querySelector(selectors.stickyAddCart);
    var stickySelectOptions = document.querySelector(selectors.stickySelectOptions);

    if (stickyAddCart) {
      stickyAddCart.addEventListener('click', handleStickyAddCart);
    }

    if (stickySelectOptions) {
      stickySelectOptions.addEventListener('click', handleStickySelectOptions);
    }

    if (stickyCart) {
      initStickyCartObserver.bind(this)();
    }
  }

  function handleStickyAddCart() {
    var productForm = document.querySelector(selectors.productForm);
    var formAjaxSubmit = productForm.querySelector('[type="submit"]');

    if (settings.ajaxSubmit) {
      formAjaxSubmit.click();
    } else {
      productForm.submit();
    }
  }

  function handleStickySelectOptions() {
    var stickyCart = document.querySelector(selectors.stickyCart);
    var productForm = document.querySelector(selectors.productForm);
    var productFormPosition = window.pageYOffset + productForm.getBoundingClientRect().top;
    var stickyCartHeight = stickyCart.scrollHeight;
    Avatar.theme.Utilities.smoothScrollTo(0, productFormPosition - stickyCartHeight, 700);
  }

  function initStickyCartObserver() {
    var stickyCart = document.querySelector(selectors.stickyCart);
    var header = document.querySelector('#shopify-section-header');
    var stickyCartSettings = JSON.parse(stickyCart.dataset.stickyCartSettings);
    var position = stickyCartSettings.position,
        mobile = stickyCartSettings.mobile,
        desktop = stickyCartSettings.desktop;
    var mqSmall = this.mqSmall;

    function callback(entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          stickyCart.classList.add(classes.active);
          if (!mobile && mqSmall.matches) return;
          if (!desktop && !mqSmall.matches) return;

          if (headerIsSticky() && position === 'top') {
            hideHeader(header);
          }
        } else {
          stickyCart.classList.remove(classes.active);

          if (headerIsSticky() && position === 'top') {
            showHeader(header);
          }
        }
      });
    }

    var target = this.intersect;
    var observer = new IntersectionObserver(callback);
    observer.observe(target);
  }

  var headerIsSticky = function headerIsSticky() {
    var header = document.querySelector('[data-section-type="header"]');
    var headerSettings = JSON.parse(header.dataset.sectionSettings);
    var isSticky = headerSettings.sticky;
    return isSticky;
  };

  var showHeader = function showHeader(header) {
    header.classList.remove('tw-transition-opacity', 'tw-duration-150', 'tw-opacity-0', 'tw-pointer-events-none');
  };

  var hideHeader = function hideHeader(header) {
    header.classList.add('tw-transition-opacity', 'tw-duration-150', 'tw-opacity-0', 'tw-pointer-events-none');
  };
  /* Linked Options */


  var optionsMap = {};

  function updateOptionsInSelector(selectorIndex, product) {
    var key;
    var container = document.querySelector(selectors.sectionById(sectionId));

    function getKey(optionLevel) {
      var option;
      var checkedValue;

      if (optionLevel === 1) {
        // eslint-disable-next-line prefer-destructuring
        option = container.querySelectorAll(selectors.productOption)[0];
        checkedValue = option.querySelector(selectors.checkedInput).value;
      } else {
        option = container.querySelectorAll(selectors.productOption)[0].querySelector(selectors.checkedInput).value;
        option += ' / ';
        option += container.querySelectorAll(selectors.productOption)[1].querySelector(selectors.checkedInput).value;
        checkedValue = option;
      }

      return checkedValue;
    }

    switch (selectorIndex) {
      case 0:
        key = 'root';
        break;

      case 1:
        key = getKey(selectorIndex);
        break;

      case 2:
        key = getKey(selectorIndex);
        break;

      default:
        console.log('error');
    }

    var initialValue = key;
    var availableOptions = optionsMap[initialValue];
    var swatchInputOptionRow = container.querySelectorAll(selectors.swatchInputByOptionIndex(selectorIndex));
    var colorIndex = product.options.findIndex(function (option) {
      var value = option;

      if (_typeof(option) === 'object') {
        value = option.name;
      }

      return value.toLowerCase() === 'color';
    });

    if (colorIndex !== -1) {
      var optionContainer = container.querySelector(selectors.productOptionByIdex(colorIndex));
      var colorValue = optionContainer.querySelector(selectors.checkedInput).value;
      var span = optionContainer.querySelector('.color-option-label');

      if (span) {
        span.innerHTML = colorValue;
      }
    }

    if (settings.hideSingleOption && !settings.showUnavailable) {
      var optionRow = swatchInputOptionRow[0].closest(selectors.productOption);

      if (availableOptions.length <= 1) {
        optionRow.classList.add(classes.hidden);
      } else {
        optionRow.classList.remove(classes.hidden);
      }
    }

    swatchInputOptionRow.forEach(function (swatchInput) {
      var swatchValue = swatchInput.value;
      var swatchContainer = swatchInput.parentElement;

      if (availableOptions && availableOptions.includes(swatchValue)) {
        swatchContainer.classList.remove(classes.hidden, classes.soldout);
        swatchContainer.querySelector('input').removeAttribute('disabled');
        swatchContainer.querySelector('label').classList.remove(classes.defaultCursor);
        swatchContainer.classList.add(classes.showOption);
        swatchContainer.classList.remove(classes.hideOption);
      } else {
        if (!settings.showUnavailable) {
          swatchContainer.classList.add(classes.hidden);
        }

        if (settings.disableUnavailable) {
          swatchContainer.querySelector('label').classList.add(classes.defaultCursor);
          swatchContainer.querySelector('input').setAttribute('disabled', true);
        }

        swatchContainer.classList.remove(classes.showOption);
        swatchContainer.classList.add(classes.hideOption);
        swatchContainer.classList.add(classes.soldout);
      }
    });

    if (settings.disableUnavailable) {
      var currentCheckedOption = null;
      var currentOptions = document.querySelectorAll(selectors.swatchByOptionIndex(selectorIndex));
      currentOptions.forEach(function (option) {
        var optionInput = option.querySelector('input');

        if (optionInput.checked) {
          currentCheckedOption = option.querySelector(selectors.checkedInput).parentElement;
        }
      }); // Make sure currentCheckedOption is not null, for products with no variants

      if (currentCheckedOption) {
        if (currentCheckedOption.classList.contains(classes.hideOption)) {
          var firstAvailableOption = currentOptions[0].parentElement.querySelector(".form-check-swatch.".concat(classes.showOption));
          firstAvailableOption && firstAvailableOption.querySelector('input').click();
        }
      }
    }
  }

  function initLinkedOptions(product) {
    // Building our mapping object.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i]; // Add code back to variant.available if needed

      if (variant.available) {
        // Gathering values for the 1st drop-down.
        optionsMap.root = optionsMap.root || [];
        optionsMap.root.push(variant.option1);
        optionsMap.root = Avatar.theme.Utilities.uniq(optionsMap.root); // Gathering values for the 2nd drop-down.

        if (product.options.length > 1) {
          var key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = Avatar.theme.Utilities.uniq(optionsMap[key]);
        } // Gathering values for the 3rd drop-down.


        if (product.options.length === 3) {
          var _key = "".concat(variant.option1, " / ").concat(variant.option2);

          optionsMap[_key] = optionsMap[_key] || [];

          optionsMap[_key].push(variant.option3);

          optionsMap[_key] = Avatar.theme.Utilities.uniq(optionsMap[_key]);
        }
      }
    }

    updateSwatches(product);
  }

  function updateSwatches(product) {
    updateOptionsInSelector(0, product);
    if (product.options.length > 1) updateOptionsInSelector(1, product);
    if (product.options.length === 3) updateOptionsInSelector(2, product);
  }

  function initEventHandlers() {
    if (!this.productForm) {
      return;
    }

    this.productForm.addEventListener('keydown', handleOnKeyDown);
  }

  function handleOnKeyDown(evt) {
    if ([SPACE_KEY_CODE, ENTER_KEY_CODE].includes(evt.keyCode)) {
      var container = document.querySelector(selectors.sectionById(sectionId));
      var labels = container.querySelectorAll(selectors.productOptionLabel);
      labels.forEach(function (label) {
        if (label === document.activeElement) {
          evt.preventDefault();
          var inputSelector = selectors.swatchInputById(label.getAttribute('for'));
          document.querySelector(inputSelector).checked = true;
          var changeEvent = new Event('change');
          document.querySelector(inputSelector).dispatchEvent(changeEvent);
        }
      });
    }
  }

  var destroy = function destroy() {
    if (_this.productForm) {
      _this.productForm.removeEventListener('keydown', handleOnKeyDown);
    }

    _this.productQuantityStep.forEach(function (step) {
      step.removeEventListener('click', handleQuantityClick);
    });

    if (_this.productQuantityInput) {
      _this.productQuantityInput.removeEventListener('change', handleQuantityChange);
    } // this.productFormInstance.destroy();


    if (_this.productMediaNav) {
      _this.productMediaNav.removeEventListener('keydown', handleThumbnailKeyDown);

      _this.productMediaNavButtons.forEach(function (button) {
        button.removeEventListener('click', handleThumbnailClick.bind);
      });
    }

    if (_this.productMediaNav && _this.productMediaNav.initialized) {
      _this.productMediaNavSwiper.destroy();
    }

    if (_this.productMedia && _this.productMedia.initialized) {
      _this.productMediaSwiper.destroy();
    }

    _this.productTabs.destroy();

    if (settings.ajaxSubmit) {
      DesignModeUtil.initAjaxAddToCartDestroy();
    }

    Avatar.theme.ProductModel.removeSectionModels(sectionId);
  }; // TODO: Don't need this in production since this won't load on any other page.


  if (Avatar.theme.current.pageType === 'product') {
    init();
  }

  return {
    init: init,
    destroy: destroy,
    initProductMedia: initProductMedia,
    initProductForm: initProductForm,
    initProductQuantity: initProductQuantity,
    initLinkedOptions: initLinkedOptions,
    getProductJson: getProductJson
  };
}

Avatar.theme.Product = new Product();


    // If we reached this module (the entry point), it means no one accepted the HRM.
    // Let's reload the page then.
    if (module.hot) {
      module.hot.accept();
      // On first load, module.hot.data is undefined since it is not an update...
      // So if we do have a data object, it means we've been HMR'ed.
      if (module.hot.data) {
        window.__shopify_pipeline_should_reload__ = true;
      }
    }
  